/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var gramaticaXMLDESC = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,7],$V1=[2,5],$V2=[14,23],$V3=[1,18],$V4=[2,16],$V5=[6,7,22],$V6=[1,53],$V7=[1,54],$V8=[1,36],$V9=[1,32],$Va=[1,33],$Vb=[1,34],$Vc=[1,35],$Vd=[1,37],$Ve=[1,38],$Vf=[1,39],$Vg=[1,40],$Vh=[1,41],$Vi=[1,42],$Vj=[1,43],$Vk=[1,44],$Vl=[1,45],$Vm=[1,46],$Vn=[1,47],$Vo=[1,48],$Vp=[1,49],$Vq=[1,50],$Vr=[1,51],$Vs=[1,52],$Vt=[1,55],$Vu=[2,47],$Vv=[2,20],$Vw=[9,10,12,18,22,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"INICIO":3,"ENCABEZADO":4,"RAICES":5,"EOF":6,"menor":7,"interr_cierra":8,"xml":9,"version":10,"igual":11,"cadena":12,"encoding":13,"mayor":14,"RAIZ":15,"RAICESP":16,"OBJETO":17,"identificador":18,"LISTAATRIBUTOS":19,"OBJETOP":20,"OBJETOPP":21,"menorDIV":22,"division":23,"OBJETOS":24,"LISTA_TEXTO":25,"ATRIBUTOS":26,"ATRIBUTO":27,"ATRIBUTOSP":28,"IDENTIFICADOR":29,"LISTA_TEXTOP":30,"alfanumerico":31,"numero":32,"decimal":33,"caracter":34,"less_than":35,"greater_than":36,"ampersand":37,"apostrophe":38,"quotation_mark":39,"mas":40,"menos":41,"coma":42,"ptcoma":43,"punto":44,"parizq":45,"parder":46,"apostofre":47,"dos_puntos":48,"numeral":49,"ecoding":50,"OBJETOSP":51,"$accept":0,"$end":1},
terminals_: {2:"error",6:"EOF",7:"menor",8:"interr_cierra",9:"xml",10:"version",11:"igual",12:"cadena",13:"encoding",14:"mayor",18:"identificador",22:"menorDIV",23:"division",31:"alfanumerico",32:"numero",33:"decimal",34:"caracter",35:"less_than",36:"greater_than",37:"ampersand",38:"apostrophe",39:"quotation_mark",40:"mas",41:"menos",42:"coma",43:"ptcoma",44:"punto",45:"parizq",46:"parder",47:"apostofre",48:"dos_puntos",49:"numeral",50:"ecoding"},
productions_: [0,[3,3],[4,11],[5,2],[16,2],[16,0],[15,1],[17,4],[20,5],[20,2],[21,1],[21,1],[19,1],[19,0],[26,2],[28,2],[28,0],[27,3],[25,2],[30,2],[30,0],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[29,1],[24,2],[51,2],[51,0]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:
this.$ = $$[$0-1]; ListaReporteGrl.push("INICIO -> ENCABEZADO RAICES" + "," + "ENCABEZADO.VAL, RAICES.VAL");
									var nodos = this.$; var ecod = $$[$0-2]; var listRepor = ListaReporteGrl; var err = ListaErrores; 
									return {objetos:nodos, ecoding:ecod, listaRG:listRepor, errores:err};  
break;
case 2:
this.$ = $$[$0-2]; ListaReporteGrl.push("ENCABEZADO -> '<' '?' xml version '=' cadena encoding '=' cadena '?' '>'" + "," + "'<' '?' xml version '=' cadena encoding '=' cadena '?' '>'");
break;
case 3:
$$[$0].push($$[$0-1]); this.$ = $$[$0]; ListaReporteGrl.push("RAICES -> RAIZ RACESP" + "," + "RAICESP.ADD(RAIZ.VAL), RAICES.VAL=RAICESP.VAL"); 
break;
case 4:
$$[$0].push($$[$0-1]); this.$ = $$[$0]; ListaReporteGrl.push("RAICESP -> RAIZ RACESP" + "," + "RAICESP.ADD(RAIZ.VAL), RAICESP.VAL=RAICESP.VAL"); 
break;
case 5:
this.$ = []; ListaReporteGrl.push("RAICESP -> e" + "," + "e"); 
break;
case 6:
this.$ = $$[$0]; ListaReporteGrl.push("RAIZ -> OBJETO" + "," + "RAIZ.VAL = OBJETO.VAL"); 
break;
case 7:
this.$ = new Objeto($$[$0-2],LTexto,_$[$0-3].first_line, _$[$0-3].first_column,$$[$0-1],$$[$0]); LTexto="";
	ListaReporteGrl.push("OBJETO -> menor identificador LISTAATRIBUTOS OBJETOSP" + "," + "OBJETO.VAL = LISTAOBJETOS[].VAL, OBJETO.VAL = OBJETOP[].VAL"); 
break;
case 8:
this.$=$$[$0-3]; ListaReporteGrl.push("OBJETO -> mayor OBJETOPP menorDIv identificador mayor" + "," + "OBJETOP.VAL = OBJETOPP[].VAL"); 
break;
case 9:
this.$=[]; ListaReporteGrl.push("OBJETO -> division mayor" + "," + "OBJETOP.VAL = []"); 
break;
case 10:
this.$=$$[$0]; ListaReporteGrl.push("OBJETOPP -> OBJETOS" + "," + "OBJETOPP.VAL = OBJETOS[].VAL"); 
break;
case 11:
LTexto = $$[$0]; this.$=[]; ListaReporteGrl.push("OBJETO -> LISTA_TEXTO" + "," + "OBJETOPP.VAL = [], LTexto.val = LISTA_TEXTO.VAL"); 
break;
case 12:
this.$ = $$[$0]; ListaReporteGrl.push("LISTAATRIBUTOS -> ATRIBUTOS" + "," + "LISTAATRIBUTOS.VAL = ATRIBUTOS[].VAL"); 
break;
case 13:
this.$ = []; this.$ = []; ListaReporteGrl.push("LISTAATRIBUTOS -> e" + "," + "e"); 
break;
case 14:
$$[$0].push($$[$0-1]); this.$ = $$[$0]; $$[$0].push($$[$0-1]); this.$ = $$[$0]; ListaReporteGrl.push("ATRIBUTOS -> ATRIBUTO ATRIBUTOSP" + "," + "ATRIBUTOSP.ADD(ATRIBUTO.VAL), ATRIBUTOS.VAL=ATRIBUTOSP.VAL"); 
break;
case 15:
$$[$0].push($$[$0-1]); this.$ = $$[$0]; ListaReporteGrl.push("ATRIBUTOS -> ATRIBUTO ATRIBUTOSP" + "," + "ATRIBUTOSP.ADD(ATRIBUTO.VAL), ATRIBUTOS.VAL=ATRIBUTOSP.VAL"); 
break;
case 16:
this.$ = []; ListaReporteGrl.push("ATRIBUTOSP -> e" + "," + "e"); 
break;
case 17:
this.$ = new Atributo($$[$0-2], $$[$0], _$[$0-2].first_line, _$[$0-2].first_column); ListaReporteGrl.push("ATRIBUTO -> identificador igual cadena" + "," + "ATRIBUTO.VAL = cadena.lexval"); 
break;
case 18: case 19:
$$[$0] = $$[$0-1] + ' ' + $$[$0]; this.$ = $$[$0]; ListaReporteGrl.push("LISTA_TEXTO -> IDENTIFICADOR LISTA_TEXTOP" + "," + "LISTA_TEXTO.VAL"); 
break;
case 20:
this.$ = []; ListaReporteGrl.push("LISTA_TEXTOP -> e" + "," + "e"); 
break;
case 21:
 this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> identificador" + "," + "IDENTIFICADOR.val = identificador.lexval"); 
break;
case 22:
 this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> alfanumerico" + "," + "IDENTIFICADOR.val = alfanumerico.lexval"); 
break;
case 23:
 this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> numero" + "," + "IDENTIFICADOR.val = numero.lexval"); 
break;
case 24:
 this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> decimal" + "," + "IDENTIFICADOR.val = decimal.lexval"); 
break;
case 25:
 this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> cadena" + "," + "IDENTIFICADOR.val = cadena.lexval"); 
break;
case 26:
 this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> caracter" + "," + "IDENTIFICADOR.val = caracter.lexval"); 
break;
case 27:
 $$[$0] = "<"; this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> less_than" + "," + "IDENTIFICADOR.val = less_than.val, less_than.lexval = &lt;"); 
break;
case 28:
 $$[$0] = ">"; this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> greater_than" + "," + "IDENTIFICADOR.val = greater_than.val, greater_than.lexval = &gt;"); 
break;
case 29:
 $$[$0] = "&"; this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> ampersand" + "," + "IDENTIFICADOR.val = ampersand.val, ampersand.lexval = &amp;"); 
break;
case 30:
 $$[$0] = "\'"; this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> apostrophe" + "," + "IDENTIFICADOR.val = apostrophe.val, apostrophe.lexval = &apos;"); 
break;
case 31:
 $$[$0] = "\""; this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> quotation_mark" + "," + "IDENTIFICADOR.val = quotation_mark.val, quotation_mark.lexval = &quot;");
break;
case 32: case 33: case 34: case 35: case 36: case 37: case 38: case 39: case 40: case 41: case 42: case 43: case 44:
this.$ = $$[$0]; ListaReporteGrl.push("IDENTIFICADOR -> simbolo" + "," + "IDENTIFICADOR.val = simbolo.lexval");
break;
case 45:
$$[$0].push($$[$0-1]); this.$ = $$[$0]; ListaReporteGrl.push("OBJETOS -> OBJETO OBJETOSP" + "," + "OBJETOSP.ADD(OBJETO.VAL), OBJETOS.VAL=OBJETOSP.VAL"); 
break;
case 46:
$$[$0].push($$[$0-1]); this.$ = $$[$0]; ListaReporteGrl.push("OBJETOS -> OBJETO OBJETOSP" + "," + "OBJETOSP.ADD(OBJETO.VAL), OBJETOS.VAL=OBJETOSP.VAL");
break;
case 47:
this.$ = []; ListaReporteGrl.push("OBJETOSP -> e" + "," + "e"); 
break;
}
},
table: [{3:1,4:2,7:[1,3]},{1:[3]},{5:4,7:$V0,15:5,17:6},{8:[1,8]},{6:[1,9]},{6:$V1,7:$V0,15:11,16:10,17:6},o([6,7],[2,6]),{18:[1,12]},{9:[1,13]},{1:[2,1]},{6:[2,3]},{6:$V1,7:$V0,15:11,16:14,17:6},o($V2,[2,13],{19:15,26:16,27:17,18:$V3}),{10:[1,19]},{6:[2,4]},{14:[1,21],20:20,23:[1,22]},o($V2,[2,12]),o($V2,$V4,{28:23,27:24,18:$V3}),{11:[1,25]},{11:[1,26]},o($V5,[2,7]),{7:$V0,9:$V6,10:$V7,12:$V8,17:30,18:$V9,21:27,24:28,25:29,29:31,31:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm,44:$Vn,45:$Vo,46:$Vp,47:$Vq,48:$Vr,49:$Vs,50:$Vt},{14:[1,56]},o($V2,[2,14]),o($V2,$V4,{27:24,28:57,18:$V3}),{12:[1,58]},{12:[1,59]},{22:[1,60]},{22:[2,10]},{22:[2,11]},{7:$V0,17:62,22:$Vu,51:61},{9:$V6,10:$V7,12:$V8,18:$V9,22:$Vv,29:64,30:63,31:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm,44:$Vn,45:$Vo,46:$Vp,47:$Vq,48:$Vr,49:$Vs,50:$Vt},o($Vw,[2,21]),o($Vw,[2,22]),o($Vw,[2,23]),o($Vw,[2,24]),o($Vw,[2,25]),o($Vw,[2,26]),o($Vw,[2,27]),o($Vw,[2,28]),o($Vw,[2,29]),o($Vw,[2,30]),o($Vw,[2,31]),o($Vw,[2,32]),o($Vw,[2,33]),o($Vw,[2,34]),o($Vw,[2,35]),o($Vw,[2,36]),o($Vw,[2,37]),o($Vw,[2,38]),o($Vw,[2,39]),o($Vw,[2,40]),o($Vw,[2,41]),o($Vw,[2,42]),o($Vw,[2,43]),o($Vw,[2,44]),o($V5,[2,9]),o($V2,[2,15]),o([14,18,23],[2,17]),{13:[1,65]},{18:[1,66]},{22:[2,45]},{7:$V0,17:62,22:$Vu,51:67},{22:[2,18]},{9:$V6,10:$V7,12:$V8,18:$V9,22:$Vv,29:64,30:68,31:$Va,32:$Vb,33:$Vc,34:$Vd,35:$Ve,36:$Vf,37:$Vg,38:$Vh,39:$Vi,40:$Vj,41:$Vk,42:$Vl,43:$Vm,44:$Vn,45:$Vo,46:$Vp,47:$Vq,48:$Vr,49:$Vs,50:$Vt},{11:[1,69]},{14:[1,70]},{22:[2,46]},{22:[2,19]},{12:[1,71]},o($V5,[2,8]),{8:[1,72]},{14:[1,73]},{7:[2,2]}],
defaultActions: {9:[2,1],10:[2,3],14:[2,4],28:[2,10],29:[2,11],61:[2,45],63:[2,18],67:[2,46],68:[2,19],73:[2,2]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    _token_stack:
        var lex = function () {
            var token;
            token = lexer.lex() || EOF;
            if (typeof token !== 'number') {
                token = self.symbols_[token] || token;
            }
            return token;
        };
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
                    if (typeof action === 'undefined' || !action.length || !action[0]) {
                var errStr = '';
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push('\'' + this.terminals_[p] + '\'');
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                } else {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                });
            }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};


	var ListaErrores=[];
	var ListaReporteGrl=[];
	var LObjetos=[];
	var LTexto="";
 
    const {Objeto} = require("../Expresiones/Objeto");
    const {Atributo} = require("../Expresiones/Atributo");
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {"case-insensitive":true},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:this.begin("Comentario"); 
break;
case 1:
break;
case 2:
break;
case 3:this.popState();
break;
case 4:console.log("comentario: "+yy_.yytext)
break;
case 5:/* skip whitespace */
break;
case 6:return 22;
break;
case 7:return 40;
break;
case 8:return 41;
break;
case 9:return 'por';
break;
case 10:return 23;
break;
case 11:return 'menor_igual';
break;
case 12:return 'mayor_igual';
break;
case 13:return 7;
break;
case 14:return 14;
break;
case 15:return 11;
break;
case 16:return 43;
break;
case 17:return 44;
break;
case 18:return 42;
break;
case 19:return 45;
break;
case 20:return 46;
break;
case 21:return 8;
break;
case 22:return 47		
break;
case 23:return 48
break;
case 24:return 49
break;
case 25:return 9;
break;
case 26:return 10;
break;
case 27:return 13;
break;
case 28:return'less_than';
break;
case 29:return'greater_than';
break;
case 30:return'ampersand';
break;
case 31:return'apostrophe';
break;
case 32:return'quotation_mark';
break;
case 33:return 12
break;
case 34:return 34
break;
case 35:return 18;
break;
case 36:return 31
break;
case 37:return 33;
break;
case 38:return 32;
break;
case 39:
										ListaErrores.push('Error Lexico,' + yy_.yytext + ',' + yy_.yylloc.first_line + ',' + yy_.yylloc.first_column);
                                    
break;
case 40:return 6
break;
}
},
rules: [/^(?:<!--)/i,/^(?:[ \r\t]+)/i,/^(?:\n)/i,/^(?:-->)/i,/^(?:[^"-->"]+)/i,/^(?:\s+)/i,/^(?:<\/)/i,/^(?:\+)/i,/^(?:-)/i,/^(?:\*)/i,/^(?:\/)/i,/^(?:<=)/i,/^(?:>=)/i,/^(?:<)/i,/^(?:>)/i,/^(?:=)/i,/^(?:;)/i,/^(?:\.)/i,/^(?:,)/i,/^(?:\()/i,/^(?:\))/i,/^(?:\?)/i,/^(?:')/i,/^(?::)/i,/^(?:#)/i,/^(?:xml\b)/i,/^(?:version\b)/i,/^(?:encoding\b)/i,/^(?:&lt;)/i,/^(?:&gt;)/i,/^(?:&amp;)/i,/^(?:&apos;)/i,/^(?:&quot;)/i,/^(?:("((\\([\'\"\\bfnrtv]))|([^\"\\]+))*"))/i,/^(?:('((\\([\'\"\\bfnrtv]))|([^\'\\]))'))/i,/^(?:[a-zA-Z_][a-zA-Z0-9_ñÑá-ü]*)/i,/^(?:([a-zA-Z0-9_-]){1,16})/i,/^(?:(([0-9]+\.[0-9]*)|(\.[0-9]+)))/i,/^(?:[0-9]+)/i,/^(?:.)/i,/^(?:$)/i],
conditions: {"comment":{"rules":[0,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40],"inclusive":true},"Etiqueta":{"rules":[],"inclusive":false},"Comentario":{"rules":[1,2,3,4],"inclusive":false},"INITIAL":{"rules":[0,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = gramaticaXMLDESC;
exports.Parser = gramaticaXMLDESC.Parser;
exports.parse = function () { return gramaticaXMLDESC.parse.apply(gramaticaXMLDESC, arguments); };
exports.main = function commonjsMain (args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}